import { render, staticRenderFns } from "./FrontProductList.vue?vue&type=template&id=cda49b5e&scoped=true"
import script from "./FrontProductList.vue?vue&type=script&lang=js"
export * from "./FrontProductList.vue?vue&type=script&lang=js"
import style0 from "./FrontProductList.vue?vue&type=style&index=0&id=cda49b5e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda49b5e",
  null
  
)

export default component.exports